import VueSanitize from 'vue-sanitize'

// Local sanitizer, without changing global editor or rendering options.
const host = { prototype: {} }
VueSanitize.install(host, {
    allowedTags: ['p', 'div', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li', 'h2', 'h3', 'h4', 'blockquote'],
    allowedAttributes: {}
})
export const nettoyerAnamnese = value => host.prototype.$sanitize(String(value || ''))
export const champsAnamnese = ['debut', 'signe_associe', 'signe_negatif', 'traitement_avt_admission', 'bilan_avt_admission', 'evolution']
export function modeAnamnese(rows = []) {
    const marker = rows.find(row => row.field_name === 'mode_saisie')
    return marker && marker.field_content === 'texte' ? 'texte' : 'sections'
}
export function lignesAnamnese(rows = []) {
    const mode = modeAnamnese(rows)
    return rows.filter(row => mode === 'texte' ? row.field_name === 'texte_libre' : champsAnamnese.includes(row.field_name))
}
export function brouillonAnamnese(rows = []) {
    const value = name => {
        const row = rows.find(item => item.field_name === name)
        return row ? row.field_content || '' : ''
    }
    return {
        mode: modeAnamnese(rows),
        texte: nettoyerAnamnese(value('texte_libre')),
        champs: champsAnamnese.map(field_name => ({ field_name, value: value(field_name) }))
    }
}
export function chargeAnamnese(mode, champs, texte) {
    return [{ field_name: 'mode_saisie', value: mode }].concat(mode === 'texte'
        ? [{ field_name: 'texte_libre', value: nettoyerAnamnese(texte) }]
        : champs.map(champ => ({ ...champ })))
}
